<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="change-password preloader-wrapper">
    <h2 *ngIf="account$ | async as account">{{ 'password.title' | translate: {username: account.login | gtthTextEscape} }}</h2>

    <div *ngIf="passwordChangeAttempted" [class]="requestResult.isSuccess ? 'alert-success' : 'alert-danger'" class="alert">
        {{ requestResult.message | translate }}
    </div>

    <div class="control-label">{{ 'userManagement.popups.password' | translate }}</div>
    <sui-password-component [config]="newPassword"></sui-password-component>

    <winde-password-strength-bar [passwordToCheck]="newPassword.value"></winde-password-strength-bar>

    <div class="control-label">{{ 'userManagement.popups.confirmPassword' | translate }}</div>
    <sui-password-component [config]="confirmationPassword"></sui-password-component>

    <button (click)="changePassword()" windeGreen>
        {{ 'entity.action.save' | translate }}
    </button>
</div>
